export var ExternalUrlConfigAction;
(function (ExternalUrlConfigAction) {
  ExternalUrlConfigAction["VIEW_DETAIL"] = "viewDetail";
  ExternalUrlConfigAction["SUBSTITUTION"] = "substitution";
})(ExternalUrlConfigAction || (ExternalUrlConfigAction = {}));
export var ExternalUrl;
(function (ExternalUrl) {
  ExternalUrl["DEFAULT"] = "#";
})(ExternalUrl || (ExternalUrl = {}));
